import { SHARE_TYPE_TO_ENDPOINT_MAP } from 'components/Pages/Admin/Itineraries/Share/constants';
import { ITINERARIES_ITEM_TYPES } from 'constants/index';
import api from 'utils/axios';
import { ITINERARIES_ITEM_TYPE_TO_ROUTE_SEGMENT_MAP } from 'utils/itineraries/functions';

import { accountIdSelector } from '../../user/selectors';

import { updateTourRequestRecentEventAction } from './index';

export const shareWithUserTypeThunk = (values, shareType) => (dispatch, getStore) => {
  const accountId = accountIdSelector(getStore());
  const { id, itinerariesItemType } = values;
  const segment = ITINERARIES_ITEM_TYPE_TO_ROUTE_SEGMENT_MAP[itinerariesItemType];

  return api
    .post(`/acc/${accountId}/${segment}/${id}/share_with_${SHARE_TYPE_TO_ENDPOINT_MAP[shareType]}`, { ...values })
    .then(({ data = {} }) => {
      if (itinerariesItemType !== ITINERARIES_ITEM_TYPES.GUEST_PORTAL) {
        dispatch(updateTourRequestRecentEventAction({ id, recentEvent: data, itinerariesItemType }));
        return;
      }
    })
    .catch((error) => {
      return Promise.reject(error?.errors);
    });
};

export const saveSampleItineraryThunk = (id, data) => async (dispatch, getStore) => {
  const accountId = accountIdSelector(getStore());
  return await api
    .post(`/acc/${accountId}/sample_itineraries/${id}`, data)
    .then(({ data = {} }) => data)
    .catch((error) => {
      return Promise.reject(error?.errors);
    });
};

export const saveSampleLookbookThunk = (id, data) => async (dispatch, getStore) => {
  const accountId = accountIdSelector(getStore());
  return await api
    .post(`/acc/${accountId}/sample_lookbooks/${id}`, data)
    .then(({ data = {} }) => data)
    .catch((error) => {
      return Promise.reject(error?.errors);
    });
};
